const geoCoordMap = {
  巩义市: [113.058715, 34.684454],
  登封市: [113.057768, 34.409939],
  金水区: [113.736037, 34.805838],
  上街区: [113.283, 34.788689],
  荥阳市: [113.391523, 34.789077],
  惠济区: [113.61836, 34.888591],
  中原区: [113.551576, 34.778286],
  二七区: [113.585422, 34.670936],
  新密市: [113.440616, 34.507846],
  中牟县: [113.999921, 34.701976],
  管城回族区: [113.755313, 34.696453],
  新郑市: [113.7967, 34.454219]
};

export const converData = function(data) {
  let res = [];
  for (let i = 0; i < data.length; i++) {
    let geoCoord = geoCoordMap[data[i].countyName];
    if (geoCoord) {
      res.push({
        name: data[i].countyName,
        value: geoCoord.concat(data[i].comparyNum)
      });
    }
  }
  return res;
};

export const handleMapData = data => {
  let result = [];
  data.forEach(item => {
    result.push({
      ...item,
      value: [item.lon, item.lat]
    });
  });
  return result;
};
